<template>
  <el-card shadow="never" v-loading="loading">
    <el-table :data="leases">
      <el-table-column type="expand">
        <template slot-scope="scope">
          <CustomerLeaseLineItems
            :customer="customer"
            :invoice="{ lineItems: scope.row.lineItems, _id: scope.row._id }"
            :getMonthValue="getMonthValue"
            :lineItemBackgroundColor="lineItemBackgroundColor"
            :currencySign="currencySign"
            :hasVoidAction="false"
          />
        </template>
      </el-table-column>
      <el-table-column
        label="Start"
        prop="start"
        :width="100"
        :formatter="(row, column, cellValue) => $options.filters.formatDate(cellValue)">
      </el-table-column>
      <el-table-column
        label="End"
        prop="end"
        :width="100"
        :formatter="(row, column, cellValue) => $options.filters.formatDate(cellValue)">
      </el-table-column>
      <el-table-column label="Status" prop="status" :width="120"></el-table-column>
      <el-table-column label="Amount" prop="amount" :width="150" :formatter="(row, column, cellValue) => $options.filters.currencySign(cellValue, this.$root.state.facilityData)"></el-table-column>
      <el-table-column label="Amount Paid" prop="amountPaid" :width="150" :formatter="(row, column, cellValue) => $options.filters.currencySign(cellValue, this.$root.state.facilityData)"></el-table-column>
      <el-table-column label="Action">
        <template slot-scope="scope">
            <el-button size="small" @click="() => addChargesDialog(scope.row)">Add Charges</el-button>
            <el-popover v-if="scope.row.completed && fundsNeeded(scope.row) && fundsAvailable"
              placement="top" trigger="hover" effect="light">
              <div>
                Transfer funds from wallet to this lease.
              </div>
              <el-button slot="reference" size="small" @click="() => transferFunds(scope.row)">
                Transfer Funds
              </el-button>
            </el-popover>
            <el-popover v-if="scope.row.completed && fundsNeeded(scope.row) && !fundsAvailable"
              placement="top" trigger="hover" effect="light">
              <div>
                Write Off Due amount
              </div>
              <el-button slot="reference" size="small" @click="() => openWriteOffDialog(scope.row)">
                Write Off
              </el-button>
            </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="Documents" >
        <template slot-scope="scope">
          <a
            v-if="scope.row.agreementSigned"
            :href="scope.row.agreementOnS3"
            download
            slot="reference"
          >
            <el-tooltip class="item" effect="dark" placement="top-start">
              <template slot="content">
                <span style="font-size: 0.85rem; font-family: sans-serif">Customer Agreement</span>
              </template>
              <el-button
                size="small"
                type="primary"
                icon="el-icon-download"
              >
              </el-button>
            </el-tooltip>
          </a>
          <el-tooltip class="item" effect="dark" placement="top-start">
            <template slot="content">
              <span style="font-size: 0.85rem; font-family: sans-serif">Account Statement</span>
            </template>
            <el-button icon="el-icon-printer" size="small" type="secondary" @click="() => openAccountStatement(scope)"></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :visible.sync="writeOffDialog" @close="selectedLease = {}">
      <el-form ref="writeOffForm" :model="writeOffForm">
        <el-form-item label="Reason" :rules="[{ required: true, message: 'Please add the reason'}]" prop="details">
          <el-input v-model="writeOffForm.details"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button :disabled="!writeOffForm.details || loading" @click="writeOff">Submit</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :visible.sync="previewAccountStatementDialog" @close="selectedLease = {}" width="55%">
      <AccountStatement v-if="selectedLease && selectedLease._id" :lease="selectedLease" :customer={...customer} />
    </el-dialog>
    <el-dialog id="line-item" :visible.sync="dialogForLineItems" destroy-on-close @close="closeAddChargesDialog">
      <el-card v-loading="loading">
        <div slot="header" class="clearfix">
          <h5>Add Additional Charges.</h5>
        </div>
        <el-form :model="newLineItem" :rules="rules" ref="lineItemForm">
          <el-form-item label="Description" :rules="[
            {
              required: true,
              message: 'Please add the description',
              trigger: 'blur',
            },
          ]"
          prop="description"
          >
            <el-input v-model="newLineItem.description"> </el-input>
          </el-form-item>
          <el-form-item label="Charge Type" prop="type" :rules="[
            {
              required: true,
              message: 'Please select charge type.',
              trigger: 'blur',
            },
          ]">
            <el-select size="small" v-model="newLineItem.chargeType">
              <el-option label="Deposit" value="DEPOSIT" :disabled="true"> </el-option>
              <el-option label="Rent" value="RENT" :disabled="true"> </el-option>
              <el-option label="Fee" value="FEES"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="newLineItem.chargeType === 'RENT'" label="Units" :rules="[
            {
              required: true,
              message: 'Please select unit.',
              trigger: 'blur',
            },
          ]"
          prop="unit"
          >
            <el-select v-model="newLineItem.unit">
              <el-option :key="unit.unit" v-for="unit of selectedInvoice.unitsInfo" :value="unit.unit" :label="unit.name">
                {{ unit.name }}
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="newLineItem.chargeType === 'RENT'" label="Applied Month" prop="period">
            <el-date-picker v-model="newLineItem.period" type="month" placeholder="Pick a month">
            </el-date-picker>
          </el-form-item>
          <!-- <el-form-item v-if="newLineItem.chargeType === 'RENT'" label="Lease Next Billing">
            <el-date-picker
              v-model="newLineItem.period"
              type="month"
              placeholder="Pick a month">
            </el-date-picker>
          </el-form-item> -->
          <el-form-item v-if="newLineItem.chargeType === 'FEES'" label="Fee Type" prop="chargeType">
            <el-select size="small" v-model="newLineItemFeeType">
              <el-option value="Material Sales"></el-option>
              <el-option value="Damage"></el-option>
              <el-option value="Penalties/Violations"></el-option>
              <el-option value="Construction/Improvements"></el-option>
              <el-option value="Forklift Training"></el-option>
              <el-option value="Hourly Labour"></el-option>
              <el-option value="Other/Miscellaneous"></el-option>
              <el-option value="Utility Income"></el-option>
              <el-option value="Security" :label="facilitySecurityFeeLabel"></el-option>
              <el-option value="CC Convenience"></el-option>
              <el-option value="Late Fee"></el-option>
              <el-option value="Auction Fee"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Amount" prop="amount"
          >
            <el-input step="0.01" type="number" min="1" size="small" v-model="newLineItem.amount">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="addLineItem"> Add </el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </el-dialog>
  </el-card>
</template>

<script>
import axios from 'axios';
import { addMonths, startOfMonth, isBefore } from 'date-fns';
import { FACILITY_ACCOUNT_API_BASE, LEASING_API } from '../env';
import getMonth, { setMoveinToUTC } from '../utils/timing';
import CustomerLeaseLineItems from './CustomerLeaseLineItems';
import AccountStatement from './AccountStatement';
import { getLeaseTaxLineItem } from '../utils/pricing';

export default {
  name: 'CustomerLeaseHistory',
  props: {
    customer: { type: Object, required: true },
    facility: { type: String, required: true },
    id: { type: String, required: true },
  },
  components: { CustomerLeaseLineItems, AccountStatement },
  computed: {
    fundsAvailable() {
      if (!this.facilityAccount || !this.facilityAccount.wallet) { return false; }

      return this.facilityAccount.wallet > 0;
    },
    facilitySecurityFeeLabel() {
      let label = 'Security';

      const facility = this.$root.state.facilityData;
      if (facility && facility.securityFee && facility.securityFee.label !== '') {
        label = facility.securityFee.label;
      }

      return label;
    },
  },
  watch: {
    async facility() {
      this.loading = true;
      await this.getCustomerPastLeases();
      await this.getCustomerFacilityAccount();
      this.loading = false;
    },
    async id() {
      this.loading = true;
      await this.getCustomerPastLeases();
      await this.getCustomerFacilityAccount();
      this.loading = false;
    },
    async customerPastLeases() {
      try {
        this.loading = true;
        await this.getCustomerPastLeases();
        await this.getCustomerFacilityAccount();
        this.loading = false;
      } catch (err) {
        this.loading = false;
      }
    },
  },
  data() {
    const amountValidator = (_rule, value, callback) => {
      const amount = Number(value);
      if (Number.isNaN(amount)) {
        return callback(new Error('Please input digits'));
      }

      if (amount <= 0) {
        return callback(new Error('Amount should be greater than 0'));
      }

      return callback();
    };

    return {
      rules: {
        amount: [
          { required: true, message: 'Please give a valid amount', trigger: 'change' },
          { validator: amountValidator, trigger: ['blur', 'change'] },
        ],
      },
      facilityAccount: {},
      facilityAccountExists: false,
      leases: [],
      loading: true,
      previewAccountStatementDialog: false,
      selectedLease: {},
      dialogForLineItems: false,
      selectedInvoice: null,
      writeOffDialog: false,
      writeOffForm: {
        details: '',
      },
      newLineItem: {
        description: '',
        chargeType: '',
        amount: 0,
        parsedAmount: 0,
        accountBalance: 0,
        period: new Date(),
        dueDate: new Date(),
        createdAt: new Date(),
        type: 'CREDIT',
        unit: null,
      },
    };
  },
  async mounted() {
    this.loading = true;
    await Promise.all([
      this.getCustomerPastLeases(),
      this.getCustomerFacilityAccount(),
    ]);
    this.loading = false;
  },
  methods: {
    openWriteOffDialog(lease) {
      this.selectedLease = lease;
      this.writeOffDialog = true;
    },
    async writeOff() {
      this.loading = true;
      const dueAmount = this.selectedLease.amount - this.selectedLease.amountPaid;
      const writeOffTransaction = {
        amount: dueAmount,
        facility: this.selectedLease.facility,
        facilityAccount: this.facilityAccount._id,
        invoice: this.selectedLease._id,
        details: this.writeOffForm.details,
        createdBy: this.$keycloak.tokenParsed.email,
        customer: this.id,
      };

      const response = await axios.post(`${LEASING_API}/v1/${this.facility}/${this.selectedLease._id}/writeoff`, {
        ...writeOffTransaction,
      }, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });

      this.writeOffForm.details = '';
      this.writeOffDialog = false;

      await Promise.all([
        this.getCustomerPastLeases(),
        this.getCustomerFacilityAccount(),
      ]);
      this.loading = false;
      return response;
    },
    closeAddChargesDialog() {
      this.selectedInvoice = null;
      this.dialogForLineItems = false;
    },
    fundsNeeded(invoice) {
      return invoice.amount > invoice.amountPaid;
    },
    async getCustomerFacilityAccount() {
      this.loading = true;
      if (!this.facility || !this.id) {
        this.facilityAccountExists = false;
        this.facilityAccount = { wallet: 0, amount: 0, amountPaid: 0, deposit: 0, depositToBeRefunded: 0 };
        return;
      }
      try {
        const response = await axios.get(`${FACILITY_ACCOUNT_API_BASE}/v1/${this.facility}/${this.id}`, {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });

        if (response.data) {
          this.facilityAccountExists = true;
          this.facilityAccount = response.data;
        }

        if (this.facilityAccount.amount || this.facilityAccount.amountPaid) {
          this.facilityAccount.wallet = this.facilityAccount.amountPaid - this.facilityAccount.amount;
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
        this.facilityAccountExists = false;
        this.facilityAccount = { wallet: 0, amount: 0, amountPaid: 0, deposit: 0, depositToBeRefunded: 0 };
      }
    },
    async transferFunds(invoice) {
      this.loading = true;
      try {
        const response = await axios.patch(
          `${FACILITY_ACCOUNT_API_BASE}/v1/account/sync/customer/${this.customer._id}/facility/${this.facility}/lease/${invoice._id}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${this.$keycloak.token}`,
            }
          }
        );
      } catch(err) {
        this.$message.error({
          message: `There was an error transfering funds to the lease: ${err.message}`,
        });

      }
      await this.getCustomerPastLeases();
      this.loading = false;
    },
    openAccountStatement(scope) {
      this.previewAccountStatementDialog = true;
      this.selectedLease = scope.row;
    },
    async getCustomerPastLeases() {
      const response = await axios.get(`${LEASING_API}/v1/${this.facility}/${this.id}/past/lease`, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });

      this.leases = response.data;
    },
    lineItemBackgroundColor(lineItem) {
      if (lineItem.voided) {
        return 'linear-gradient(35deg, #ff9966, #ff5e62)';
      } else if (lineItem.type === 'DEBIT') {
        return 'linear-gradient(35deg, #4B8673, #0f9b0f)';
      }
      return 'linear-gradient(35deg, #009aca, #0c3da7)';
    },
    getMonthValue(value) {
      return getMonth(value);
    },
    addChargesDialog(item) {
      this.dialogForLineItems = true;
      this.selectedInvoice = item;
    },
    async addLineItem() {
      this.loading = true;
      this.$refs.lineItemForm.validate(async (valid) => {
        try {
          if (valid) {
            this.newLineItem.parsedAmount = Number(this.newLineItem.amount);
            const newLineItem = this.newLineItem;
            newLineItem.details = this.newLineItem.chargeType;
            newLineItem.addedBy = this.$keycloak.tokenParsed.email;
            this.newLineItem.custom = true;
            if (this.newLineItem.chargeType === 'FEES' && !this.newLineItemFeeType) {
              this.loading = false;
              this.$message.error({
                // title: 'Error',
                message: 'Please select Fee type.',
              });
              return;
            }

            const currentDate = new Date();
            if (this.newLineItem.chargeType === 'FEES' && this.newLineItemFeeType) {
              this.newLineItem.feeType = this.newLineItemFeeType;

              const firstOfNextMonth = startOfMonth(addMonths(currentDate, 1));
              const endDate = new Date(this.selectedInvoice.end);
              // eslint-disable-next-line no-nested-ternary
              const firstOfMoveoutMonth = this.selectedInvoice.end && isBefore(
                startOfMonth(endDate), firstOfNextMonth)
                ? startOfMonth(endDate) : null;

              const periodForFeeItem = firstOfMoveoutMonth || firstOfNextMonth;

              this.newLineItem.dueDate = setMoveinToUTC(
                periodForFeeItem,
              );
              this.newLineItem.period = setMoveinToUTC(
                periodForFeeItem,
              );
            } else if (this.newLineItem.chargeType === 'DEPOSIT') {
              this.newLineItem.dueDate = setMoveinToUTC(
                currentDate,
              );
              this.newLineItem.period = setMoveinToUTC(
                currentDate,
              );
            } else {
              this.newLineItem.dueDate = setMoveinToUTC(
                this.newLineItem.period,
              );
              this.newLineItem.period = setMoveinToUTC(
                this.newLineItem.period,
              );
            }

            if (this.newLineItem.chargeType === 'RENT' && !this.newLineItem.unit) {
              this.loading = false;
              this.$message.error({
                // title: 'Error',
                message: 'Please select the unit to add its rent.',
              });
              return;
            }

            this.newLineItem.accountBalance =
              (this.selectedInvoice.amount +
                this.newLineItem.parsedAmount) -
              this.selectedInvoice.amountPaid || 0;

            const taxItem = getLeaseTaxLineItem(this.newLineItem, this.$root.state.facilityData);

            await axios.put(
              `${LEASING_API}/v1/${this.facility}/${this.selectedInvoice._id}/add/line/item`,
              {
                newLineItem: {
                  ...newLineItem,
                  amount: newLineItem.parsedAmount,
                },
                ...(taxItem.amount ? { taxItem } : {}),
              },
              {
                headers: {
                  Authorization: `Bearer ${this.$keycloak.token}`,
                },
              },
            );

            await this.getCustomerPastLeases();
            this.loading = false;
            this.dialogForLineItems = false;
            this.$notify.success({
              title: 'Success',
              message: 'Line Item added successfully.',
            });
          } else {
            this.loading = false;
          }
        } catch (err) {
          this.loading = false;
          this.$notify.error({
            title: 'Error',
            message: err.response && err.response.data ? err.response.data : err.message,
          });
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/CustomerLeaseHistory.vue